import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "brand card" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = { class: "brand__image" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "brand__name" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "brand__gender" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Collection: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: $props.blok.image.filename,
          alt: $props.blok.title
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: $props.blok.url.url,
          target: "_blank",
          class: "stretched-link"
        }, _toDisplayString($props.blok.title), 9, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.blok.gender, (gender) => {
          return (_openBlock(), _createElementBlock("span", { key: gender }, _toDisplayString($props.blok.gender.length > 1 && gender === "men" ? gender + " & " : gender), 1))
        }), 128))
      ])
    ])
  ]))
}